import type {ReactNode} from 'react';
import {useState} from 'react';
import type {AssistantMessageTextPartActionsRowProps} from './assistant-message-text-part-actions-row.types';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import Tooltip from 'react-bootstrap/Tooltip';
import {isTouchDevice} from '@Utils/browser.util';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import {GROWL_TYPE, showMessageGrowl} from '@Components/message-growl';
import {ChatMessagePartType} from '@Components/ai-chat-window/ai-chat-window.types';

export function AssistantMessageTextPartActionsRow({...props}: AssistantMessageTextPartActionsRowProps): ReactNode {
  const [isCopied, setIsCopied] = useState(false);

  if (props.isMessageStreaming) {
    return null;
  }

  const doesMessageHaveImageParts = props.message.parts.some((part) => part.type === ChatMessagePartType.MODEL_GENERATED_IMAGE);

  if (doesMessageHaveImageParts) {
    return null;
  }

  const onClickCopy = (): void => {
    void navigator.clipboard.writeText(props.text);

    setIsCopied(true);

    showMessageGrowl({
      type: GROWL_TYPE.SUCCESS,
      text: window.i18next.t('pmwjs_copied'),
      interval: 2000,
    });
  };

  const onTooltipToggle = (nextShow: boolean): void => {
    if (!nextShow) {
      setIsCopied(false);
    }
  };

  const getCopyIcon = (): ReactNode => {
    return (
      <OverlayTrigger
        trigger={['hover', 'focus']}
        onToggle={onTooltipToggle}
        overlay={
          <Tooltip className={`spacing-m-b-1 _rounded-arrow ${isTouchDevice() ? '_invisible' : ''}`}>
            {isCopied ? window.i18next.t('pmwjs_copied') : window.i18next.t('pmwjs_copy')}
          </Tooltip>
        }
        delay={{show: 0, hide: 0}}
        placement="top"
        offset={undefined}
      >
        <Icon size={IconSize.SIZE_ICON_20} type={IconType.GHOST} shape={IconShape.CIRCLE} icon={'icon-copy'} onClick={onClickCopy} />
      </OverlayTrigger>
    );
  };

  return <div className={`flex-h-row flex-align-items-center spacing-m-0 ${!props.isMobile ? 'gap-1' : ''} _position-relative ${props.className ?? ''}`}>{getCopyIcon()}</div>;
}
